<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-form ref="detailForm" :disabled="action === 'view'" :model="supplierInfo" :rules="rules" label-width="120px" class="el-form-flex">
      <el-collapse v-model="activeCollapses" class="el-card-collapse">
        <el-collapse-item title="基本信息" name="Basic">
          <el-row :gutter="20">
            <el-col :sm="24" :md="12" :lg="10">
              <div class="el-form-content">
                <el-form-item label="经营类型" prop="workingGroup">
                  <el-select v-model="supplierInfo.detail.workingGroup" class="max-width">
                    <el-option :value="12" label="普通商户" />
                  </el-select>
                </el-form-item>
                <el-form-item label="商户类型" prop="merchantType">
                  <el-select v-model="supplierInfo.detail.merchantType" class="max-width">
                    <el-option :value="1" label="企业商户" />
                    <el-option :value="2" label="个体工商户" />
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐人邀请码" prop="inviteCode">
                  <el-input v-model.trim="supplierInfo.inviteCode" placeholder="请输入推荐人邀请码" class="max-width" />
                  <span v-if="supplierInfo.inviterName" class="pl-10">{{ supplierInfo.inviterName }}</span>
                </el-form-item>
                <el-form-item label="商户全称" prop="shopName">
                  <el-input v-model.trim="supplierInfo.shopName" placeholder="请输入营业执照上的全称" />
                </el-form-item>
                <el-form-item label="商户简称" prop="shortName">
                  <el-input v-model.trim="supplierInfo.shortName" placeholder="将在支付完成页面向消费者展示" />
                </el-form-item>
                <el-form-item label="营业执照编号" prop="detail.licenceNo">
                  <el-input v-model.trim="supplierInfo.detail.licenceNo" placeholder="请输入统一社会信用代码" />
                </el-form-item>
                <el-form-item label="执照有效期类型">
                  <el-radio-group v-model="supplierInfo.detail.licenseDateType" class="max-width">
                    <el-radio :label="1">非长期</el-radio>
                    <el-radio :label="2">长期</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="supplierInfo.detail.licenseDateType === 1" label="营业执照有效期" prop="detail.licenseDate">
                  <el-date-picker
                    key="licenseDateType1"
                    v-model="supplierInfo.detail.licenseDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
                <el-form-item v-else label="营业执照有效期" prop="detail.licenseStart">
                  <el-date-picker
                    key="licenseDateType2"
                    v-model="supplierInfo.detail.licenseStart"
                    type="date"
                    placeholder="开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    class="max-width"
                  />
                </el-form-item>
                <el-form-item label="所在区域" prop="regionInfo">
                  <el-cascader
                    v-if="showRegion"
                    ref="regionCascader"
                    v-model="supplierInfo.regionInfo"
                    :props="{ value: 'regionCode', label: 'regionName' }"
                    :options="regionOptions"
                    placeholder="请选择所在区域"
                    clearable
                    style="width:100%"
                    @change="regionChange"
                  />
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model.trim="supplierInfo.address" placeholder="请输入详细地址" />
                </el-form-item>
                <el-form-item label="积分抵扣" prop="discount">
                  <el-input v-model="supplierInfo.discount" type="number" min="0" max="30" placeholder="请输入优惠折扣" class="max-width">
                    <span slot="suffix">%</span>
                  </el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :sm="24" :md="12" :lg="{span: 10, offset: 4}">
              <div class="el-form-content">
                <el-form-item label="登录手机号" prop="mobile">
                  <el-input v-model="supplierInfo.mobile" type="number" placeholder="请输入11位手机号码" class="max-width" oninput="if(value.length>11)value=value.slice(0,11)" />
                </el-form-item>
                <el-form-item v-if="action === 'create'" label="登录密码" prop="password">
                  <el-input v-model="supplierInfo.password" show-password placeholder="请输入登录密码" class="max-width" />
                </el-form-item>
                <el-form-item v-if="action !== 'create'" label="平台商户编号">
                  <el-input v-model="supplierInfo.merchantId" disabled placeholder="平台商户编号" />
                </el-form-item>
                <el-form-item label="法人姓名" prop="detail.legalName">
                  <el-input v-model="supplierInfo.detail.legalName" placeholder="请输入法人姓名" />
                </el-form-item>
                <el-form-item label="法人身份证号码" prop="detail.legalIdCard">
                  <el-input v-model="supplierInfo.detail.legalIdCard" placeholder="请输入法人身份证号码" />
                </el-form-item>
                <el-form-item label="证件有效期类型">
                  <el-radio-group v-model="supplierInfo.detail.cardDateType" class="max-width">
                    <el-radio :label="1">非长期</el-radio>
                    <el-radio :label="2">长期</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="supplierInfo.detail.cardDateType === 1" label="法人证件有效期" prop="detail.cardDate">
                  <el-date-picker
                    key="cardDateType1"
                    v-model="supplierInfo.detail.cardDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
                <el-form-item v-else label="法人证件有效期" prop="detail.legalCardStart">
                  <el-date-picker
                    key="cardDateType2"
                    v-model="supplierInfo.detail.legalCardStart"
                    type="date"
                    placeholder="开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    class="max-width"
                  />
                </el-form-item>
                <el-form-item label="营业时间" prop="openHours">
                  <el-time-picker v-model="supplierInfo.openHours[0]" format="HH:mm" value-format="HH:mm" :editable="false" placeholder="开始时间" class="max-width" />
                  <span class="ml-10 mr-10">至</span>
                  <el-time-picker v-model="supplierInfo.openHours[1]" format="HH:mm" value-format="HH:mm" :editable="false" placeholder="打烊时间" class="max-width" />
                </el-form-item>
                <el-form-item label="门店电话" prop="phone">
                  <el-input v-model="supplierInfo.phone" type="number" placeholder="请输入门店电话" class="max-width" />
                </el-form-item>
                <el-form-item label="特色介绍" prop="feature">
                  <el-input v-model="supplierInfo.feature" placeholder="请输入特色介绍" />
                </el-form-item>
                <el-form-item label="资质编号" prop="detail.qualification">
                  <el-input v-model.trim="supplierInfo.detail.qualification" placeholder="请输入资质编号，如：粤卫食证字[2007]第0307A123456" />
                </el-form-item>
                <el-form-item label="排序" prop="sortBy">
                  <el-input v-model="supplierInfo.sortBy" type="number" min="0" placeholder="请输入排列顺序" class="max-width" />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="账户信息" name="Bank">
          <detail-account v-model="supplierInfo" />
        </el-collapse-item>
        <el-collapse-item title="证件信息" name="Photo">
          <detail-photo v-model="images" :detail="supplierInfo.detail" :disabled="action !== 'view'" @preview="handlePreview" />
        </el-collapse-item>
      </el-collapse>

      <el-image ref="elImage" style="width: 0; height: 0;" :src="previewImg" :preview-src-list="previewList" />
    </el-form>

    <div class="app-form-button-height" />

    <div class="app-form-button-group">
      <el-button icon="el-icon-back" @click="onBack">返回列表</el-button>
      <el-button type="info" @click="onCreate">新增供应商</el-button>
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import { rules } from './validate'
import { uploadFile } from '@/api/oss'
import { getDetail, saveDetail } from '@/api/supplier'
import { detailAccount, detailPhoto } from '@/components/ShopDetail'

export default {
  name: 'SupplierDetail',
  components: { detailAccount, detailPhoto },
  data() {
    return {
      loading: false,
      action: 'create',
      supplierId: '',
      supplierInfo: {
        detail: {},
        discount: 20,
        openHours: [],
        regionInfo: []
      },
      rules,
      images: [],
      previewImg: '',
      previewList: [],
      showRegion: true,
      activeCollapses: ['Basic', 'Bank', 'Photo'],
      regionOptions: this.$store.getters.regionMap
    }
  },
  mounted() {
    this.supplierId = this.$route.query.id || ''
    this.action = this.$route.query.action || 'create'

    this.supplierId ? this.loadData() : this.initData()
  },
  methods: {
    loadData() {
      this.loading = true
      getDetail(this.supplierId).then(response => {
        const supplierInfo = Object.assign({}, response)
        if (supplierInfo.detail) {
          supplierInfo.detail.licenseDateType = supplierInfo.detail.licenseExpire ? 1 : 2
          supplierInfo.detail.licenseDate = supplierInfo.detail.licenseExpire ? [supplierInfo.detail.licenseStart, supplierInfo.detail.licenseExpire] : []
          supplierInfo.detail.cardDateType = supplierInfo.detail.legalCardExpire ? 1 : 2
          supplierInfo.detail.cardDate = supplierInfo.detail.legalCardExpire ? [supplierInfo.detail.legalCardStart, supplierInfo.detail.legalCardExpire] : []
          supplierInfo.openHours = supplierInfo.openTime ? supplierInfo.openTime.split(' - ') : []

          this.showRegion = false
          supplierInfo.regionInfo = supplierInfo.regionCode ? supplierInfo.regionCode.split(/,\s*/) : []
        } else {
          supplierInfo.detail = Object.assign({}, this.initDetail())
        }
        this.supplierInfo = Object.assign({}, supplierInfo)
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false; this.showRegion = true })
      })
    },
    initData() {
      this.supplierInfo = Object.assign({}, {
        address: '',
        inviteCode: '',
        shopName: '',
        shortName: '',
        discount: 20,
        openHours: [],
        regionInfo: [],
        mobile: '',
        password: '',
        merchantId: '',
        phone: '',
        feature: '',
        sortBy: '',
        detail: this.initDetail()
      })
    },
    initDetail() {
      return {
        workingGroup: 12,
        merchantType: 2,
        accountType: 1,
        licenceNo: '',
        licenseDateType: 1,
        licenseDate: '',
        licenseStart: '',
        legalName: '',
        legalIdCard: '',
        cardDateType: 1,
        cardDate: '',
        legalCardStart: '',
        qualification: ''
      }
    },
    onBack() {
      this.$router.go(-1)
    },
    onCreate() {
      this.supplierId ? this.initData() : this.$refs.detailForm.resetFields()
    },
    regionChange(regionValue) {
      this.supplierInfo.regionCode = (regionValue && regionValue.length) ? regionValue.join(',') : ''
      this.supplierInfo.regionName = (regionValue && regionValue.length) ? this.$refs.regionCascader.getCheckedNodes()[0].pathLabels.join('') : ''
    },
    sameAddress(checkStatus) {
      if (checkStatus) this.supplierInfo.deliveryAddress = this.supplierInfo.shippingAddress
    },
    handlePreview(image) {
      this.previewImg = image.value
      this.previewList = [image.value]
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    onSubmit() {
    }    
  }
}
</script>

<style lang="scss" scoped>
  .app-container {
    min-height: initial;
    .el-radio-group {
      display: inline-flex;
      align-items: center;
      .el-radio {
        flex: 1;
      }
    }
    .el-form-item {
      .max-width {
        max-width: 200px;
      }
      .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
        max-width: 100%;
        width: 100%;
      }
    }
  }
</style>
